import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/browser";
import { createBrowserHistory } from "history";
import { Router, Switch, Route } from "react-router-dom";
import store, { persistor, persistanceOn } from "store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import lightBlue from "@material-ui/core/colors/lightBlue";
import red from "@material-ui/core/colors/red";

import LoadingBox from "common/components/LoadingBox";
import ErrorBoundary from "common/components/ErrorBoundary";

import AppUrlListener from "./appUrlListener";
import { getDeviceInfo, isIosDevice } from "./deviceInfo";

// core components
import UserSplash from "layouts/UserSplash.jsx";
import Public from "layouts/Public.jsx";
import OAuthLogin from "layouts/OAuthLogin.jsx";
import NewUserLinkAccount from "layouts/NewUserLinkAccount.jsx";

import "assets/scss/material-dashboard-pro-react.scss?v=1.5.0";
import { version } from "../package.json";

import * as serviceWorker from "./serviceWorker";
import config from "config.js";

// Toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import config from "config";
const theme = createMuiTheme({
  palette: {
    primary: lightBlue,
    secondary: red,
  },
});

/*

window.location.replace(
  config.AUTH.ADDRESS +
    config.AUTH.APP_PATH +
    "?r=" +
    (process.env.NODE_ENV === "development" ? "myaccountdev" : "myaccount") +
    "&route=changepassword"
);
*/

//const swconfig = {};
//swconfig.onUpdate = function (registration) {
//  const waitingServiceWorker = registration.waiting;

//  if (waitingServiceWorker) {
//    waitingServiceWorker.addEventListener("statechange", (event) => {
//      if (event.target.state === "activated") {
//        window.location.reload();
//      }
//    });
//    waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
//  }

//  //console.log("will reload");
//  //window.location.replace(config.AUTH.ADDRESS + config.AUTH.APP_PATH);
//  return null;
//};
//serviceWorker.register(swconfig);
serviceWorker.unregister();
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}

console.log("App version - " + version);
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    release: "myaccount@" + version,
    dsn: "https://ce2d3a1542af4f69aa513ed6ef003600@sentry.io/1524485",
  });
}

const hist = createBrowserHistory();
const RouterRoot = (props) => {
  const [isIos, setIsIos] = useState();
  const [deviceInfo, setDeviceInfo] = useState();
  useEffect(() => {
    const getData = async () => {
      const isIosResponse = await isIosDevice();
      setIsIos(isIosResponse);
      if (isIosDevice) {
        const deviceInfo = await getDeviceInfo();
        setDeviceInfo(deviceInfo);
        Sentry.setTag("ios app build", deviceInfo.appBuild);
      }
    };
    getData();
  }, []);
  return (
    <Router history={hist}>
      <AppUrlListener />
      <Switch>
        <Route path={config.MYACCOUNT.APP_PATH + "/login"}>
          <OAuthLogin
            onAuthenticated={() => {
              const returnPath = new URLSearchParams(
                window.location.search
              ).get("rp");
              if (
                returnPath &&
                returnPath.startsWith("/") &&
                !returnPath.startsWith("//")
              ) {
                window.location.replace(config.MYACCOUNT.APP_PATH + returnPath);
                return;
              }

              window.location.replace(config.MYACCOUNT.APP_PATH + "/");
            }}
          />
        </Route>
        <Route path={config.MYACCOUNT.APP_PATH + "/newuser"}>
          <NewUserLinkAccount />
        </Route>
        <Route path={config.MYACCOUNT.APP_PATH + "/public"}>
          <Public />
        </Route>
        <Route component={UserSplash} />
      </Switch>
    </Router>
  );
};

const App = (props) => {
  if (persistanceOn) {
    return (
      <Provider store={store}>
        <PersistGate loading={<LoadingBox />} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <ToastContainer />
            <RouterRoot />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    );
  }

  return (
    <Provider store={store}>
      <RouterRoot />
    </Provider>
  );
};

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById("root")
);
